import { render, staticRenderFns } from "./TitlesTextAndLinks.vue?vue&type=template&id=70633174"
import script from "./TitlesTextAndLinks.vue?vue&type=script&lang=js"
export * from "./TitlesTextAndLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports